import React from "react";
import { portfolioEnv, portfolioFooterLinks } from "../../config/portfolioEnv";

const footerLinkClass =
	"text-slate-300 transition-colors hover:text-brand-accent focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-accent";

const Footer = () => {
	const year = new Date().getFullYear();
	const { name } = portfolioEnv;

	return (
		<footer className='mt-auto border-t border-white/10 bg-brand text-white'>
			<div className='mx-auto flex max-w-6xl flex-col gap-4 px-4 py-6 text-sm md:flex-row md:items-center md:justify-between'>
				<p className='text-slate-300'>
					© {year} {name} · Mini-TypeScript demos
				</p>
				{portfolioFooterLinks.length > 0 && (
					<nav
						className='flex flex-wrap gap-x-6 gap-y-2'
						aria-label='Footer links'
					>
						{portfolioFooterLinks.map(({ label, href }) => (
							<a
								key={label}
								href={href}
								className={footerLinkClass}
								target='_blank'
								rel='noreferrer'
							>
								{label}
							</a>
						))}
					</nav>
				)}
			</div>
		</footer>
	);
};

export default Footer;
